export function getAppData() {
  return JSON.parse(localStorage.getItem("exlAppData"));
}

export function setAppData(data) {
  localStorage.setItem("exlAppData", JSON.stringify(data));
}

export function updateEmployees(employees) {
  let exlAppData = getAppData();
  if (!exlAppData) {
    exlAppData = {};
  }
  exlAppData.employees = employees;
  setAppData(exlAppData);
}

export function getEmployees() {
  let exlAppData = getAppData();
  if (exlAppData && exlAppData.employees) {
    return exlAppData.employees;
  } else {
    return [];
  }
}

export function updatePositions(positions) {
  let exlAppData = getAppData();
  if (!exlAppData) {
    exlAppData = {};
  }
  exlAppData.positions = positions;
  setAppData(exlAppData);
}

export function getPositions() {
  let exlAppData = getAppData();
  if (exlAppData && exlAppData.positions) {
    return exlAppData.positions;
  } else {
    return [];
  }
}

export function updateRoles(roles) {
  let exlAppData = getAppData();
  if (!exlAppData) {
    exlAppData = {};
  }
  exlAppData.roles = roles;
  setAppData(exlAppData);
}

export function getRoles() {
  let exlAppData = getAppData();
  if (exlAppData && exlAppData.roles) {
    return exlAppData.roles;
  } else {
    return [];
  }
}

export function updateResponsibilities(responsibilities) {
  let exlAppData = getAppData();
  if (!exlAppData) {
    exlAppData = {};
  }
  exlAppData.responsibilities = responsibilities;
  setAppData(exlAppData);
}

export function getResponsibilities() {
  let exlAppData = getAppData();
  if (exlAppData && exlAppData.responsibilities) {
    return exlAppData.responsibilities;
  } else {
    return [];
  }
}

export function updateFilters(key, filters) {
  let exlAppData = getAppData() || {};
  exlAppData.filters = exlAppData.filters || {};
  exlAppData.filters[key] = filters;
  setAppData(exlAppData);
}

export function getFilters(key) {
  const exlAppData = getAppData();
  if(key == "redinessResponsibilityChecklist" && exlAppData && exlAppData.filters){
    return typeof exlAppData.filters[key] === 'undefined' ? ["active", "draft"] : exlAppData.filters[key];
  }
  if (exlAppData && exlAppData.filters && exlAppData.filters[key]) {
    return exlAppData.filters[key];
  }
  return [];
}

/**
 * Updates the user's employee avatar in localStorage ONLY if the employee matches the logged-in user
 * @param {Object} employee - The employee object (must have id or first_name property)
 * @param {string} avatarUrl - The new avatar URL (or empty string if removed)
 */
export function updateUserAvatarInStorage(employee, avatarUrl) {
  try {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      return;
    }

    const user = JSON.parse(userStr);
    
    // Check if the employee being updated is the logged-in user
    // Match by employee ID or first name
    const isLoggedInUser = 
      (employee?.id && user?.employee?.id && employee.id === user.employee.id) ||
      (employee?.first_name && user?.first_name && 
       employee.first_name.toLowerCase() === user.first_name.toLowerCase());
    
    // Only update if this is the logged-in user
    if (!isLoggedInUser) {
      return;
    }
    
    // Ensure employee object exists
    if (!user.employee) {
      user.employee = {};
    }
    
    // Update the avatar
    user.employee.avatar = avatarUrl || "";
      
    // Save back to localStorage
    localStorage.setItem("user", JSON.stringify(user));
    
    // Emit custom event to notify components (like SideBar) to refresh
    const event = new CustomEvent("userAvatarUpdated", { 
      detail: { employeeId: employee?.id, avatarUrl },
      bubbles: true,
      cancelable: true
    });
    
    window.dispatchEvent(event);
    document.dispatchEvent(event);
    
    // Also try to trigger via Vue's event system if available
    if (typeof window !== 'undefined' && window.Vue) {
      if (window.Vue.prototype && window.Vue.prototype.$root) {
        window.Vue.prototype.$root.$emit("userAvatarUpdated", { employeeId: employee?.id, avatarUrl });
      }
    }
    
  } catch (error) {
    console.error("Error updating user avatar in localStorage:", error);
  }
}

